export const openAddGroup = (state) => state?.varReducer?.openAddGroup;
export const openEditGroup = (state) => state?.varReducer?.openEditGroup;
export const selectedDetailGroup = (state) =>
  state?.varReducer?.selectedDetailGroup;

//service
export const openAddService = (state) => state?.varReducer?.openAddService;
export const openEditService = (state) => state?.varReducer?.openEditService;
export const selectedDetailService = (state) =>
  state?.varReducer?.selectedDetailService;

//search
export const searchSelector = (state) => state?.varReducer?.search;

//job
export const jobSelector = (state) => state?.varReducer?.job;
export const openReceiptSelector = (state) => state?.varReducer?.openReceipt;
export const selectedReceiptSelector = (state) => state?.varReducer?.selected;
export const openDetailReceiptSelector = (state) =>
  state?.varReducer?.openDetailReceipt;
export const jobServicesSelector = (state) =>
  state?.varReducer?.selectJobServices;

//gift
export const giftSelector = (state) => state?.varReducer?.gift;

//staff
export const staffSelector = (state) => state?.varReducer?.staff;
export const assignStaffSelector = (state) => state?.varReducer?.assignStaff;

//step
export const stepSelector = (state) => state?.varReducer?.step;

//step
export const openFeedbackSelector = (state) => state?.varReducer?.openFeedback;
export const staffFeedSelector = (state) => state?.varReducer?.staffFeedback;

//incomeStaff
export const dateSelector = (state) => state?.varReducer?.date;
export const labelDateSelector = (state) => state?.varReducer?.labelDate;
export const ignoreSelectJobSelector = (state) => state?.varReducer?.ignoreJob;

